import { Lock } from "lucide-react";
import useDirectCheckout from "@/hooks/useDirectCheckout";

export default function FinalCTA() {
  const { loadingKey, buy } = useDirectCheckout();

  return (
    <section id="final-cta" className="relative py-24 md:py-36 bg-[#0a0a0a] overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#FF6B00] opacity-[0.08] rounded-full blur-[160px]" />
      </div>
      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-balance leading-[0.95]">
          Your Next Rep Doesn&apos;t <span className="text-[#FF6B00]">Need A Reservation.</span>
        </h2>
        <p className="mt-6 text-lg text-white/70">Bring pickleball training home.</p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            type="button"
            data-testid="final-cta-net-entry"
            disabled={loadingKey === "net-entry"}
            onClick={() => buy({ key: "net-entry", variant: "NetEntry", productName: "Pickle Wall™ Net Training System", price: 249, category: "net" })}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/15 disabled:opacity-50 text-white font-bold uppercase tracking-wider text-sm px-8 py-4 border border-white/15 transition-all"
          >
            <Lock size={14} />
            {loadingKey === "net-entry" ? "Redirecting..." : "START WITH PICKLE WALL — $249"}
          </button>
          <button
            type="button"
            data-testid="final-cta-complete-system"
            disabled={loadingKey === "complete-system"}
            onClick={() => buy({ key: "complete-system", variant: "Standard", productName: "Pickle Wall™ Complete Training System", price: 369, category: "net" })}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#FF6B00] hover:bg-[#E66000] disabled:opacity-50 text-black font-bold uppercase tracking-wider text-sm px-8 py-4 transition-all hover:orange-glow"
          >
            <Lock size={14} />
            {loadingKey === "complete-system" ? "Redirecting..." : "GET THE COMPLETE SYSTEM — $369"}
          </button>
        </div>
      </div>
    </section>
  );
}
